module.exports = __webpack_public_path__ + "img/DeliveryTimeInfo.ec8aac90.svg";